import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import CircularProgress, {
  CircularProgressProps,
} from '@material-ui/core/CircularProgress';

export interface Props {
  isFixed?: boolean;
  progressProps?: CircularProgressProps;
}

const useStyles = makeStyles(() => ({
  progress: {
    zIndex: 4,
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.7)',
    transition: 'opacity 0.2s ease-in',
    display: 'flex',
    verticalAlign: 'middle',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fixed: {
    position: 'fixed',
  },
}));

const Loader: React.FC<Props> = ({ isFixed, progressProps }) => {
  const classes = useStyles();

  return (
    <div
      data-test-locator="Loader"
      className={cx(classes.progress, { [classes.fixed]: isFixed })}
    >
      <CircularProgress size={50} color="primary" {...progressProps} />
    </div>
  );
};

export default Loader;
